import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';
import { loginRoutes } from './login.routing';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { SlLogoModule } from '@sportlogiq/shared/sl-logo/sl-logo.module';
import { TranslateModule } from '@ngx-translate/core';
import { ChangePasswordModule } from '../shared/change-password/change-password.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SlButtonTypeDirective } from '@sportlogiq/main/shared/directive/sl-button/sl-button.directive';
import { SlLoaderComponent } from '@sportlogiq/shared/sl-loader/sl-loader.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        RouterModule.forChild(loginRoutes),
        SlLogoModule,
        TranslateModule,
        ChangePasswordModule,
        SlButtonTypeDirective,
        SlLoaderComponent
    ],
    declarations: [LoginComponent],
})
export class LoginModule {}
